import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaArrowUp, FaDownload } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import NavbarMenu from "../heroSection/NavbarMenu";
import Footer from "../footer/Footer";
import "./DriverTerms.css";
import SEO from "../SEO";

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    AOS.init({ once: true, duration: 1000, offset: 120 });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const sections = [
    {
      number: "1",
      title: t("privacy.title.1"),
      content: (
        <>
          <p>{t("privacy.content.1_intro")}</p>
          <p>
            <strong>{t("privacy.company")}</strong><br />
            {t("privacy.address")}<br />
            {t("privacy.country")}
          </p>
          <p>
            <strong>{t("privacy.phone_label")}:</strong><br />
            {t("privacy.phone")}
          </p>
          <p>
            <strong>{t("privacy.email_label")}:</strong><br />
            <a href="mailto:kontakt@transcirox.com">{t("privacy.email")}</a>
          </p>
          <p>
            <strong>{t("privacy.website_label")}:</strong><br />
            <a href="https://www.transcirox.com">www.transcirox.com</a>
          </p>
        </>
      ),
    },
    {
      number: "2",
      title: t("privacy.title.2"),
      content: (
        <>
          <p>{t("privacy.content.2_intro")}</p>
          <p>{t("privacy.content.2")}</p>
        </>
      ),
    },
    {
      number: "3",
      title: t("privacy.title.3"),
      content: (
        <>
          <p>{t("privacy.content.3_intro")}</p>
          <ul>
            <li>{t("privacy.content.3.l1")}</li>
            <li>{t("privacy.content.3.l2")}</li>
            <li>{t("privacy.content.3.l3")}</li>
            <li>{t("privacy.content.3.l4")}</li>
          </ul>
        </>
      ),
    },
    {
      number: "4",
      title: t("privacy.title.4"),
      content: (
        <>
          <p>{t("privacy.content.4_intro")}</p>
          <ul>
            <li>{t("privacy.content.4.l1")}</li>
            <li>{t("privacy.content.4.l2")}</li>
            <li>{t("privacy.content.4.l3")}</li>
            <li>{t("privacy.content.4.l4")}</li>
            <li>{t("privacy.content.4.l5")}</li>
            <li>{t("privacy.content.4.l6")}</li>
            <li>{t("privacy.content.4.l7")}</li>
            <li>{t("privacy.content.4.l8")}</li>
            <li>{t("privacy.content.4.l9")}</li>
            <li>{t("privacy.content.4.l10")}</li>
            <li>{t("privacy.content.4.l11")}</li>
            <li>{t("privacy.content.4.l12")}</li>
            <li>{t("privacy.content.4.l13")}</li>
            <li>{t("privacy.content.4.l14")}</li>
            <li>{t("privacy.content.4.l15")}</li>
          </ul>
        </>
      ),
    },
    {
      number: "5",
      title: t("privacy.title.5"),
      content: (
        <>
          <p>{t("privacy.content.5_intro")}</p>
          <ul>
            <li>{t("privacy.content.5.l1")}</li>
            <li>{t("privacy.content.5.l2")}</li>
            <li>{t("privacy.content.5.l3")}</li>
            <li>{t("privacy.content.5.l4")}</li>
            <li>{t("privacy.content.5.l5")}</li>
            <li>{t("privacy.content.5.l6")}</li>
            <li>{t("privacy.content.5.l7")}</li>
            <li>{t("privacy.content.5.l8")}</li>
          </ul>
        </>
      ),
    },
    {
      number: "6",
      title: t("privacy.title.6"),
      content: (
        <>
          <p>{t("privacy.content.6_intro")}</p>
          <ul>
            <li>{t("privacy.content.6.l1")}</li>
            <li>{t("privacy.content.6.l2")}</li>
            <li>{t("privacy.content.6.l3")}</li>
          </ul>
          <p>{t("privacy.content.6.p1")}</p>
          <p>{t("privacy.content.6.p2")}</p>
          <p>{t("privacy.content.6.p3")}</p>
        </>
      ),
    },
    {
      number: "7",
      title: t("privacy.title.7"),
      content: (
        <>
          <p>{t("privacy.content.7.p1")}</p>
          <p>{t("privacy.content.7.p2")}</p>
        </>
      ),
    },
    {
      number: "8",
      title: t("privacy.title.8"),
      content: (
        <>
          <p>{t("privacy.content.8.p1")}</p>
          <p>{t("privacy.content.8.p2")}</p>
          <p>{t("privacy.content.8.p3")}</p>
        </>
      ),
    },
    {
      number: "9",
      title: t("privacy.title.9"),
      content: (
        <>
          <p>{t("privacy.content.9_intro")}</p>
          <p>{t("privacy.content.9_intro2")}</p>
          <ul>
            <li>{t("privacy.content.9.l1")}</li>
            <li>{t("privacy.content.9.l2")}</li>
            <li>{t("privacy.content.9.l3")}</li>
            <li>{t("privacy.content.9.l4")}</li>
          </ul>
          <p>{t("privacy.content.9.p1")}</p>
        </>
      ),
    },
    {
      number: "10",
      title: t("privacy.title.10"),
      content: (
        <>
          <p>{t("privacy.content.10_intro")}</p>
          <ul>
            <li>{t("privacy.content.10.l1")}</li>
            <li>{t("privacy.content.10.l2")}</li>
            <li>{t("privacy.content.10.l3")}</li>
            <li>{t("privacy.content.10.l4")}</li>
            <li>{t("privacy.content.10.l5")}</li>
          </ul>
          <p>{t("privacy.content.10.p1")}</p>
        </>
      ),
    },
    {
      number: "11",
      title: t("privacy.title.11"),
      content: (
        <>
          <p>{t("privacy.content.11_intro")}</p>
          <ul>
            <li>{t("privacy.content.11.l1")}</li>
            <li>{t("privacy.content.11.l2")}</li>
            <li>{t("privacy.content.11.l3")}</li>
          </ul>
          <p>{t("privacy.content.11.p1")}</p>
          <p>{t("privacy.content.11.p2")}</p>
        </>
      ),
    },
    {
      number: "12",
      title: t("privacy.title.12"),
      content: (
        <>
          <p>{t("privacy.content.12_intro")}</p>
          <p>{t("privacy.content.12_intro2")}</p>
          <ul>
            <li>{t("privacy.content.12.l1")}</li>
            <li>{t("privacy.content.12.l2")}</li>
            <li>{t("privacy.content.12.l3")}</li>
            <li>{t("privacy.content.12.l4")}</li>
            <li>{t("privacy.content.12.l5")}</li>
          </ul>
          <p>{t("privacy.content.12.p1")}</p>
        </>
      ),
    },
    {
      number: "13",
      title: t("privacy.title.13"),
      content: (
        <>
          <p>{t("privacy.content.13_intro")}</p>
          <ul>
            <li>{t("privacy.rights.l1")}</li>
            <li>{t("privacy.rights.l2")}</li>
            <li>{t("privacy.rights.l3")}</li>
            <li>{t("privacy.rights.l4")}</li>
            <li>{t("privacy.rights.l5")}</li>
            <li>{t("privacy.rights.l6")}</li>
            <li>{t("privacy.rights.l7")}</li>
          </ul>
        </>
      ),
    },
    {
      number: "14",
      title: t("privacy.title.14"),
      content: (
        <>
          <p>{t("privacy.content.14.p1")}</p>
          <p>{t("privacy.content.14.p2")}</p>
        </>
      ),
    },
    {
      number: "15",
      title: t("privacy.title.15"),
      content: (
        <>
          <p>{t("privacy.content.15.p1")}</p>
          <p>{t("privacy.content.15.p2")}</p>
        </>
      ), 
    },
    {
      number: "16",
      title: t("privacy.title.16"),
      content: (
        <>
          <p>{t("privacy.content.16")}</p>
          <p>
            <strong>{t("privacy.company")}</strong><br />
            {t("privacy.address")}<br />
            {t("privacy.country")}
          </p>
          <p>
            <strong>{t("privacy.phone_label")}:</strong><br />
            {t("privacy.phone")}
          </p>
          <p>
            <strong>{t("privacy.email_label")}:</strong><br />
            <a href="mailto:kontakt@transcirox.com">{t("privacy.email")}</a>
          </p>
          <p>
            <strong>{t("privacy.website_label")}:</strong><br />
            <a href="https://www.transcirox.com">www.transcirox.com</a>
          </p>
        </>
      ),
    },
  ];

  return (
    <>
      <SEO
        title="TransCirox – Datenschutzbestimmungen | Privacy Policy"
        description="Datenschutzbestimmungen der TransCiroX GmbH. Informationen zum Schutz Ihrer personenbezogenen Daten."
        keywords="Datenschutz, Datenschutzbestimmungen, DSGVO, TransCiroX, Privacy Policy"
      />
      <NavbarMenu />

      <section className="driver-terms-page mt-5 px-5">
        <Container>
          <div className="terms-card">
            <div className="terms-header">
              <button className="back-btn" onClick={() => window.history.back()}>
                <FaArrowLeft />
              </button>
              <div>
                <h2>{t("privacy.hero.title")}</h2>
              </div>
            </div>

            <div className="terms-scroll">
              <div className="document">
                <h1>{t("privacy.mainTitle")}</h1>
                <p>{t("privacy.subtitle")}</p>
                <p>{t("privacy.last_updated")}</p>

                <hr />

                {sections.map((section) => (
                  <div key={section.number} className="document-section">
                    <h3>
                      {section.number}. {section.title}
                    </h3>
                    <div>{section.content}</div>
                    <hr />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Container>
      </section>

      {showScrollTop && (
        <button
          className="back-to-top"
          onClick={scrollToTop}
          aria-label="Back to top"
        >
          <FaArrowUp />
        </button>
      )}

      <Footer />
    </>
  );
}